import { z } from 'zod';
import { OrderDirection } from '@/constants/orderDirection';
import { IndividualTabKey, OperatorTabKey, SortColumns } from './-constants';

/** SSO 移行用フィルタ。生成スキーマ未反映だがクエリ名は BE と一致。 */
const SsoProviderTypeEnum = z.enum(['MICROSOFT', 'GOOGLE']);
const ssoFilterFields = {
  /** SSO 連携の有無で絞り込む（true=連携済 / false=未連携 / 未指定=すべて）。 */
  hasSsoLink: z.boolean().optional(),
  /** 特定 IdP に連携済みで絞り込む。 */
  ssoProviderType: SsoProviderTypeEnum.optional()
};
export const OperatorSearchSchema = z.object({
  orderDirection: z.nativeEnum(OrderDirection).default(OrderDirection.ASC).optional(),
  sortColumn: z.enum(SortColumns).optional(),
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  category: z.nativeEnum(OperatorTabKey).default(OperatorTabKey.OPERATOR_MEMBERSHIP),
  freeText: z.string().optional(),
  ...ssoFilterFields
});
export type OperatorSearchSchema = z.infer<typeof OperatorSearchSchema>;
export const IndividualSearchSchema = z.object({
  orderDirection: z.nativeEnum(OrderDirection).default(OrderDirection.ASC).optional(),
  sortColumn: z.enum(SortColumns).optional(),
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  category: z.nativeEnum(IndividualTabKey).default(IndividualTabKey.INDIVIDUAL_MEMBERSHIP),
  freeText: z.string().optional(),
  ...ssoFilterFields
});
export type IndividualSearchSchema = z.infer<typeof IndividualSearchSchema>;